module.exports = __webpack_public_path__ + "static/media/emptyList.99b81e4b.png";